import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 405C8463-0E67-48A3-B824-7C5E74423125
 * name window-restore
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/window-restore.svg
 * tags
 */
export const WindowRestoreIcon = createSvgIcon(<><path d="M4,8H8V4H20V16H16V20H4V8M16,8V14H18V6H10V8H16M6,12V18H14V12H6Z" /></>, 'WindowRestoreIcon');
export default WindowRestoreIcon